import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button, Checkbox, Dialog } from "@mui/material";
import { translate } from "../../utils/utils";
import Typography from "@mui/material/Typography";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { useTranslation } from "react-i18next";
import { TextField, useMediaQuery } from "@mui/material";
import { Search } from "tabler-icons-react";
import { InputAdornment } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F3FBF9",
    color: "#B1B4BC",
    height: "50px",
    padding: "0px 16px 0px 16px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {},
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CustomizedTables({
  data,
  head,
  handleClose,
  open,
  handleAddUseCaseToQuizz,
  handleCheckUseCase,
  selectedUseCases,
  totalPages,
  page,
  handlePage,
  handleSearch,
}) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:1400px)");

  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;

    if (scrollHeight - scrollTop === clientHeight && totalPages > page) {
      handlePage(page + 1);
    }
  };


  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xl"
      PaperProps={{
        sx: !isMobile
          ? { width: "35%", padding: "20px " }
          : { width: "80%", height: "80%", margin: "5px 0", padding: "5px " },
      }}
      disableBackdropClick
      disableEnforceFocus
    >
      <Typography
        variant="subtitle3"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <IconButton onClick={handleClose}>
          <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
        </IconButton>
        {t("back")}
      </Typography>
      <br></br>
      <Typography variant="title"> {t("choose_related_usecases")}</Typography>
      <br></br>

      <TextField
        fullWidth
        id="outlined-start-adornment"
        placeholder={t("search")}
        sx={{ mb: 3 }}
        onChange={(e) => handleSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              {" "}
              <Search size={22} strokeWidth={2} color="#8F9BB2" />
            </InputAdornment>
          ),
        }}
      />

      <TableContainer
        onScroll={handleScroll}
        component={Paper}
        className="scrollhost"
        sx={{
          width: "100%",
          height: "550px",
          minWidth: "300px",
          "&.MuiTableContainer-root": {
            borderRadius: "0px",
            boxShadow: "none",
          },
        }}
      >
        <Table
          stickyHeader
          aria-label="customized table"
          sx={{
            minWidth: "300px",
            "& .MuiTableRow-root:hover": {
              backgroundColor: "#DDF6F0",
              cursor: "pointer",
            },
          }}
        >
          <TableHead>
            <TableRow>
              {head.map((el) => (
                <StyledTableCell align={el.align}>
                  {t(el.value)}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <StyledTableRow
                key={row.id}
                hover
                onClick={() => {
                  handleCheckUseCase(row);
                }}
                role="checkbox"
                tabIndex={-1}
                sx={{
                  backgroundColor:
                    selectedUseCases.includes(row.id) && "#F3FBF9",
                }}
              >
                <StyledTableCell align="left">
                  <Checkbox
                    checked={selectedUseCases.some(
                      (item) => item.id === row.id
                    )}
                    //   onClick={ (e)=>e.stopPropagation()}

                    color="success"
                  />
                </StyledTableCell>

                <StyledTableCell align="left">
                  <Typography variant="title3">
                    {row[translate("title")] || t("not_specified")}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="left">
                  <Typography variant="title3">{row.source}</Typography>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Typography variant="title3">{row.threshold}</Typography>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Typography variant="title3">{row.coefficient}</Typography>
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Typography variant="title3">
                    {row?.questions?.length}
                  </Typography>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <br></br>
      <Button
        variant="contained"
        color="button"
        onClick={handleAddUseCaseToQuizz}
        fullWidth
      >
        {t("add")}
      </Button>
    </Dialog>
  );
}
